import { render } from "./DescriptionSection.vue?vue&type=template&id=0db58ffc"
import script from "./DescriptionSection.vue?vue&type=script&lang=js"
export * from "./DescriptionSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__